import React from 'react'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import _ from 'lodash';


export default class Item extends React.Component {
    render() {
        const Styles = {
            display: 'inline-block',
            listStyle: 'none',
            width: 180,
            height:46,
            border: '1px solid #7F7F7F',
            borderRadius: 5,
            marginBottom: 10,
            lineHeight: '46px',
            cursor: 'pointer'
        }
        const activeStyle = {
            backgroundColor: '#D3B4D6',
            display: 'inline-block',
            listStyle: 'none',
            width: 182,
            height:48,
            borderRadius: 5,
            marginBottom: 10,
            lineHeight: '48px',
            color: '#fff',
            cursor: 'pointer'
        }
        const {item, isShowCheckbox, checkIds, onTodoClick, onDelete, onChangePermission,currActive,isHasPermission} = this.props
        return (
            <li>
                {isShowCheckbox && <Checkbox color="primary" checked={_.includes(checkIds, item.id)} onChange={() =>onChangePermission(item.id)} />}
                <span style={currActive === item.id ? activeStyle : Styles} onClick={()=>onTodoClick(item.id)}>{item.name || '-'}</span>
                {isHasPermission && <IconButton onClick={() =>onDelete(item.id)}><DeleteIcon /></IconButton>}
            </li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/routes/permission/components/item.js